import { defineMessages } from 'react-intl'

// E8 F8-6 SignedOutPage strings.
const messages = defineMessages({
  title: {
    id: 'signedOut.title',
    defaultMessage: 'You have been signed out',
  },
  subtitle: {
    id: 'signedOut.subtitle',
    defaultMessage: 'You can safely close this tab, or sign in again to continue.',
  },
  signInAgain: {
    id: 'signedOut.signInAgain',
    defaultMessage: 'Sign in again',
  },
})

export default messages
